<template>
  <AtomicUiBreadcrumb :model="item" class="margin-top-s margin-bottom-s" />
</template>

<script setup>
const item = [
  {
    label: 'Home',
    url: '/',
  },
  {
    label: 'Registry',
    to: '/registry',
  },
  {
    label: 'Search',
    to: '#',
  },
];
</script>
